/**
 * @module Utilities/Dom
 * @desc Dom helper funtions
 */

/**
 * Returns a true or false value depending on whether or not the user is browsing with a mobile.
 */
export function isMobile(): boolean {
  const windowWidth = window.innerWidth;

  return windowWidth <= 992;
}
